import { HStack, IconButton, Stack } from '@chakra-ui/react';
import { ListIcon } from '@phosphor-icons/react';
import { HOME_PATH, useSettingsStore } from '@supsupclub/ui-components';
import { Link } from 'react-router-dom';

import SupHLogo from '../../../assets/h-logo.svg?react';
import { AnimatedBox } from '../../../common/components/animated-box';

export const Header = () => {
  const setShowSettings = useSettingsStore(
    (store) => store.setShowSettingsState,
  );

  return (
    <AnimatedBox animation="fadeInDown" height="100%" width="100%">
      <Stack
        padding="0 24px"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        height="100%"
        width="100%"
        bg="rgba(255, 255, 255, 0.72)"
        backdropFilter="blur(20px) saturate(180%)"
      >
        <Link to={HOME_PATH} aria-label="Go to homepage">
          <SupHLogo
            style={{
              maxWidth: '65%',
              transition: 'transform 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as SVGElement).style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as SVGElement).style.transform = 'scale(1)';
            }}
          />
        </Link>
        <HStack alignItems="center">
          <IconButton
            aria-label="Open settings menu"
            variant="ghost"
            color="gray.500"
            borderRadius="full"
            css={{
              transition: 'all 0.2s ease',
              '&:hover': {
                bg: 'brand.50',
                transform: 'scale(1.08)',
              },
              '&:active': {
                transform: 'scale(0.95)',
              },
            }}
            onClick={() => {
              setShowSettings(true);
            }}
          >
            <ListIcon size={24} color="currentColor" />
          </IconButton>
        </HStack>
      </Stack>
    </AnimatedBox>
  );
};
